// extracted by mini-css-extract-plugin
export default {"k9TableOuter":"k9_k9TableOuter__LGhbw","companyTableOuter":"k9_companyTableOuter__HuRo-"};